export default __webpack_public_path__ + "static/media/coupon-blue.c32938ee.svg";